function hashToNumber(seed: string): number {
  let hash = 0;
  for (const char of seed) {
    hash = (hash * 31 + char.charCodeAt(0)) | 0;
  }
  return Math.abs(hash);
}

function pickSeededIndex(seed: string, variantCount: number): number {
  return hashToNumber(seed) % variantCount;
}

function pickSeeded<Item>(seed: string, items: Item[]): Item {
  return items[pickSeededIndex(seed, items.length)]!;
}

function shuffleSeeded<Item>(seed: string, items: Item[]): Item[] {
  const hash = hashToNumber(seed);

  return items
    .map(
      (item, index) =>
        [item, (hash * (index + 1) + index) % (items.length + 1)] as const,
    )
    .toSorted((left, right) => left[1] - right[1])
    .map(([item]) => item);
}

export { pickSeeded, pickSeededIndex, shuffleSeeded };
